<template>
  <f7-page login-screen class="pageGenerator">
    <navbar></navbar>

    <f7-block class="text-center text-uppercase ">
      <h4>{{ 'generator.training_blocks_generator' | translate }}</h4>
    </f7-block>
    <f7-block>
      <p class="text-justify">{{ 'generator.training_blocks_generator_description' | translate }}</p>
    </f7-block>

    <f7-list form no-hairlines-md @submit.prevent="exportPdf">

      <div style="margin: 0 15px;">
        <label class="item-label" for="">{{ 'generator.logo' | translate }}</label>
        <div v-if="!uploadImage">
          <div class="wrapperUpload">
            <f7-button class="d-flex" raised small>
                <img height="14px" class="icon" src="/static/icons/upload.svg" alt />
            </f7-button>
            <input type="file" @change="onFileChange" accept="image/*" />
          </div>
        </div>
        <f7-card v-else>
          <div class="logoPreviewWrapper">
            <f7-button class="close" @click="uploadImage = null" raised small>
              <img height="8px" src="/static/icons/close.svg" alt />
            </f7-button>
            <img class="logoPreview" :src="uploadImage">
          </div>
        </f7-card>
      </div>

      <f7-list-item :title="'global.type_block_generator' | translate" class="custom-select">
        <select name="type_block_generator" v-model="typeBlockGenerator">
          <option v-for="block in typesBlockGenerator" :key="block.id" :value="block.id" :selected="block.id == typeBlockGenerator">
              {{block.label | translate}}
          </option>
        </select>
      </f7-list-item>

      <f7-list-input
          :label="'global.file_name' | translate"
          type="text"
          :placeholder="'global.file_name' | translate"
          :value="imageTitle"
          @input="imageTitle = $event.target.value"
          required
          validate
          :error-message="'global.required' | translate"
          clear-button
        >
        </f7-list-input>

      <f7-block class="text-center text-uppercase">
        <h4>{{ 'generator.choose' | translate }}</h4>
      </f7-block>

      <f7-block>
        <f7-card>
          <div class="groupSessions">
            <div v-for="(session, key) in typeBlockGenerator === 'soccer' ? sessionsFootball : sessionsFutsal" @click="selected = key" :key="key" class="groupSessionsItem" :class="{active:selected == key}">
              <div class="image" @click="choiceSession" >
                <img :src="'/static/generator/' + session.src">
              </div>
              <div v-if="selected == key" class="checkWrapper">
                <img class="check" height="15px" src="/static/icons/done-full.svg" alt="check">
              </div>
            </div>
          </div>
        </f7-card>
      </f7-block>

      <f7-block class="text-center">
        <f7-button v-if="!isExport" type="submit" raised>{{ 'generator.save_pdf' | translate }}</f7-button>
        <f7-button v-else raised>
          <f7-preloader :size="20" color="white"></f7-preloader>
        </f7-button>
      </f7-block>

    </f7-list>

    <f7-block>
      <p class="text-justify">{{ 'generator.error' | translate }} <a href="https://soccer-sessions.com/#contact" class="font-weight-bold external" target="_blank">{{ 'global.write_to_us' | translate }}</a>.</p>
    </f7-block>

  </f7-page>
</template>
<script>
import { jsPDF } from "jspdf";
import Navbar from "@/components/Navbar/Navbar.vue";
import CONSTANTS from "@/utils/constants.js"

export default {
  components: {
    Navbar,
  },
  data: () => {
    return {
      typesBlockGenerator: CONSTANTS.TYPE_BLOCK_GENERATOR,
      typeBlockGenerator: 'soccer',
      uploadImage: '',
      opacity: 'data:image/png;base64,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',
      sessionImages: '',
      imageWidth: 0,
      imageHeight: 0,
      imageTitle: '',
      allowableTypes: ['jpg', 'jpeg', 'png'],
      maximumSize: 3000000,
      isUpload: false,
      isChoiceSession: false,
      isExport: false,
      sessionsFutsal: [{ 
              src: 'znak_bloczki_trenerskie_2_cale_boiska_kratka_futsal.png'
          },
          { 
              src: 'znak_bloczki_trenerskie_2_cale_boiska_kratka_2_futsal.png'
          },
          { 
              src: 'znak_bloczki_trenerskie_4_cale_boiska_kratka_futsal.png'
          },
          { 
              src: 'znak_bloczki_trenerskie_4_polowy_boiska_kratka_futsal.png'
          },
          { 
              src: 'znak_bloczki_trenerskie_4_puste_boiska_kratka_futsal.png'
          },
          { 
              src: 'znak_bloczki_trenerskie_cale_boisko_futsal.png'
          },
          { 
              src: 'znak_bloczki_trenerskie_cale_boisko_kratka_futsal.png'
          },
          { 
              src: 'znak_bloczki_trenerskie_cale_boisko_pol_boiska_futsal.png'
          },
          { 
              src: 'znak_bloczki_trenerskie_konspekt_cale_boisko_1_futsal.png'
          },
          { 
              src: 'znak_bloczki_trenerskie_konspekt_cale_boisko_2_futsal.png'
          },
          { 
              src: 'znak_bloczki_trenerskie_konspekt_pol_boiska_1_futsal.png'
          },
          { 
              src: 'znak_bloczki_trenerskie_konspekt_pol_boiska_2_futsal.png'
          },
          { 
              src: 'znak_bloczki_trenerskie_konspekt_puste_boisko_1_futsal.png'
          },
          { 
              src: 'znak_bloczki_trenerskie_konspekt_puste_boisko_2_futsal.png'
          },
          { 
              src: 'znak_bloczki_trenerskie_notatnik_kratka_futsal.png'
          },
          { 
              src: 'znak_bloczki_trenerskie_notatnik_linia_futsal.png'
          },
          { 
              src: 'znak_bloczki_trenerskie_notatnik_pusta_futsal.png'
          },
          { 
              src: 'znak_bloczki_trenerskie_pol_boiska_kratka_futsal.png'
          }],
      sessionsFootball: [
          { 
              src: 'znak_bloczki_trenerskie_2_cale_boiska_kratka.png'
          },
          { 
              src: 'znak_bloczki_trenerskie_2_cale_boiska_kratka_2.png'
          },
          { 
              src: 'znak_bloczki_trenerskie_4_cale_boiska_kratka.png'
          },
          { 
              src: 'znak_bloczki_trenerskie_4_polowy_boiska_kratka.png'
          },
          { 
              src: 'znak_bloczki_trenerskie_4_puste_boiska_kratka.png'
          },
          { 
              src: 'znak_bloczki_trenerskie_cale_boisko.png'
          },
          { 
              src: 'znak_bloczki_trenerskie_cale_boisko_kratka.png'
          },
          { 
              src: 'znak_bloczki_trenerskie_cale_boisko_pol_boiska.png'
          },
          { 
              src: 'znak_bloczki_trenerskie_konspekt_cale_boisko_1.png'
          },
          { 
              src: 'znak_bloczki_trenerskie_konspekt_cale_boisko_2.png'
          },
          { 
              src: 'znak_bloczki_trenerskie_konspekt_pol_boiska_1.png'
          },
          { 
              src: 'znak_bloczki_trenerskie_konspekt_pol_boiska_2.png'
          },
          { 
              src: 'znak_bloczki_trenerskie_konspekt_puste_boisko_1.png'
          },
          { 
              src: 'znak_bloczki_trenerskie_konspekt_puste_boisko_2.png'
          },
          { 
              src: 'znak_bloczki_trenerskie_notatnik_kratka.png'
          },
          { 
              src: 'znak_bloczki_trenerskie_notatnik_linia.png'
          },
          { 
              src: 'znak_bloczki_trenerskie_notatnik_pusta.png'
          },
          { 
              src: 'znak_bloczki_trenerskie_pol_boiska_kratka.png'
          }
      ],
      selected: undefined

    };
  },
  methods: {
    choiceSession(img) {
            let promise = this.getBase64Image(img.target.currentSrc);
            promise.then(dataURL => {
                this.sessionImages = dataURL;
                this.isChoiceSession = true;
            })
        },
    getBase64Image(url) {
        return new Promise((resolve, reject)=> {
            let img = new Image();
            img.onload = function() {
                let canvas = document.createElement("canvas");
                canvas.width = img.width;
                canvas.height = img.height;
                let ctx = canvas.getContext("2d");
                ctx.drawImage(img, 0, 0);
                let dataURL = canvas.toDataURL("image/png");
                resolve(dataURL.replace(/^data:image\/(png|jpg|jpeg|pdf);base64,/, ""));
              };
              img.src = url;
        });
    },
    exportPdf() {
        if (!this.isUpload) {
            this.$f7.toast.create({
                text: 'Upload a logo!',
                position: 'bottom',
                closeTimeout: 3000,
            }).open();
            return false;
        }
        if (this.imageTitle === '') {
            this.$f7.toast.create({
                text: 'Enter a file name!',
                position: 'bottom',
                closeTimeout: 3000,
            }).open();
            return false;
        }
        if (!this.isChoiceSession) {
            this.$f7.toast.create({
                text: 'Choose a training block!',
                position: 'bottom',
                closeTimeout: 3000,
            }).open();
            return false;
        }
        this.isExport = true;
        setTimeout(() => { 
            let doc = new jsPDF('p', 'mm', 'a4');
            let ratio = 0.264583;
            let width = doc.internal.pageSize.getWidth();  
            let height = doc.internal.pageSize.getHeight();
            let centerX = (width - this.imageWidth * ratio) / 2
            let centerY = (height - this.imageHeight * ratio) / 2
            doc.addImage(this.uploadImage, 'JPEG', centerX, centerY, this.imageWidth * ratio, this.imageHeight * ratio);
            doc.addImage(this.opacity, 'JPEG', (width - 800 * ratio) / 2, (height - 800 * ratio) / 2, 800 * ratio, 800 * ratio);
            doc.addImage(this.sessionImages, 'PNG', 0, 0, width, height);
            doc.save(this.imageTitle + '.pdf');
            this.isExport = false;
        }, 500);
    },
    onFileChange(e) {
      this.uploadImage = ''
      if (!this.allowableTypes.includes(e.target.files[0].name.split('.').pop().toLowerCase())) {
          this.$f7.toast.create({
              text: 'Invalid file format. Acceptable file formats are: JPG, JPEG, PNG!',
              position: 'bottom',
              closeTimeout: 3000,
          }).open();
          this.isUpload = false;
          return false
      }
      if (e.target.files[0].size > this.maximumSize) {
          this.$f7.toast.create({
              text: 'The file is too heavy. The maximum size of the file is: 3 MB!',
              position: 'bottom',
              closeTimeout: 3000,
          }).open();
          this.isUpload = false;
          return false
      }

      if (e.target.files && e.target.files[0]) {
          this.imageTitle = e.target.files[0].name.split('.').slice(0, -1).join('.')

          const reader = new FileReader();
          reader.onload = (e) => {
            const image = new Image();
            image.src = e.target.result;

            image.onload = (e) => {
              const ratio = image.height / image.width

              if (image.height >= 700 || image.width >= 700) {
                this.imageHeight = ratio * 700 / 1;
                this.imageWidth = 700
              } else {
                this.imageHeight = image.height;
                this.imageWidth = image.width;
              }
            };

            this.uploadImage = e.target.result;
            this.isUpload = true;
          }
          reader.readAsDataURL(e.target.files[0]);
      }
    },
  }
};
</script>

<style lang="scss">
@import "@/assets/scss/pages/generator.scss";
</style>